import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RouterParamSeervice } from 'src/app/service/params/params.service';
import { environment } from 'src/environments/environment';
import {UrlValidationService} from "../../service/url-validation/url-validation.service";

@Component({
    selector: 'app-success-screen',
    templateUrl: './success-screen.component.html',
    styleUrls: ['./success-screen.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuccessScreenComponent implements OnInit {
  redirectUrl: string = '';
  isocode: string = '';
  countryCode: string = '';

  backToApp: boolean = false;
  image: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public params: RouterParamSeervice,
    private translation: TranslateService,
    private urlValidation: UrlValidationService
  ) {
    this.isocode =  translation.currentLang ?? 'en';
    if(this.isocode === 'en'){
      window.location.href = environment.notFoundUrl;
    }
    this.countryCode = this.isocode.split('-')[1];

    this.route.queryParams.subscribe((params) => {
      const validationResult = this.urlValidation.validateRedirectUrl(params['redirectUrl']);
      this.backToApp = validationResult.isValid;
      this.redirectUrl = validationResult.url;
    });
  }
  ngOnInit(): void {
    this.image =
      'registration/assets/img/Kaercher_Reinigung+Kaiser-Wilhelm-Denkmal.jpg';
  }
  login() {
    if (this.backToApp) {
      console.log("Redirecting to:", this.redirectUrl);
      window.location.href = this.redirectUrl;
    } else {
      window.location.href = environment.mykaercher + '/' + this.isocode;
    }
  }

  toHomepage() {
    window.location.href =
      environment.corporateUrl + '/' + this.countryCode.toLowerCase();
  }
}
